// Whether a thread page with its own reply box (ThreadReplyBox) is open.
// replyCompose (actions/compose.js) uses this to tell that box apart from
// other places the compose form is shown (the compose page, a DM chat):
// replying to another post of the thread opens that post's page, with the
// box right under it, instead of filling a box under a different post.

let shown = 0;

export const threadReplyBoxShown = () => shown > 0;

/** Marks the box as shown; returns the function that unmarks it */
export const markThreadReplyBoxShown = () => {
  shown += 1;

  return () => {
    shown -= 1;
  };
};
